module.exports = __webpack_public_path__ + "static/media/acct_change-password.836331dc.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/acct_change-password.md
// module id = 1076
// module chunks = 0